module.exports = __webpack_public_path__ + "static/img/marke15.bc739af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/marke15.jpg
// module id = TvxU
// module chunks = 0